import React from 'react';
import PropTypes from 'prop-types';
import ButtonModalSecondary from '../ButtonModalSecondary';
import './styles.scss';

const ButtonModalSecondaryCompact = ({ classNames = [], ...props }) => (
    <ButtonModalSecondary
        {...props}
        classNames={['custom-btn-modal-secondary-compact', ...classNames]}
    />
);

ButtonModalSecondaryCompact.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonModalSecondaryCompact;
